module.exports = __webpack_public_path__ + "img/SKWINKELNetActieGeschenkenCA526C.b44c35ee.png";